import CheckoutProceed from "../../components/ui/CheckoutProceed";

import styles from "./styles.module.scss";

const GetStartedPage = () => {
  return (
    <div className={styles.getStartedPage}>
      <CheckoutProceed />
    </div>
  );
};

export default GetStartedPage;
